<template>
    <p>Edit</p>
</template>

<script>
export default {
  props: ['task']
}
</script>
